import { createContext, useContext } from 'react';

interface LanguageModalContextType {
  openLanguageModal: () => void;
}

const LanguageModalContext = createContext<LanguageModalContextType>({
  openLanguageModal: () => {}
});

export const useLanguageModal = () => useContext(LanguageModalContext);

export default LanguageModalContext;